var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import * as _ from 'lodash';
import { BitConditionModel } from './bit-condition-model';
import { FlagDataType } from '../../../../core/variable/flagDateType-enum';
import { DataMonitorPermission } from '../../../../core/variable/data-monitor-permission';
import { BitwiseDataType } from '../../../../core/variable/flag-data-type';
import { VARIABLE_SERVICE } from '../../../../core/variable/variable.service';
import { calcMaxBitIndex } from '../../../../core/variable/data-type';
import { VariableName } from '../../../../core/variable/variable-name';
import { ConfigureComponentBase } from '../../../../../../shared/configure-component-base';
import { BitConditonLogic } from './bit-condition-logic';
var BitConditionComponent = /** @class */ (function (_super) {
    __extends(BitConditionComponent, _super);
    function BitConditionComponent(injector, bitConditionTypeOptionService, variableService) {
        var _this = _super.call(this, injector) || this;
        _this.bitConditionTypeOptionService = bitConditionTypeOptionService;
        _this.variableService = variableService;
        _this.variableNameChangeEvent = new EventEmitter();
        _this.bitIndexChangeEvent = new EventEmitter();
        _this.bitIndex = 0;
        _this.isBitwiseIndex = false;
        _this.bitwiseDataType = BitwiseDataType;
        _this.dataType = FlagDataType.Bool;
        _this.readModel = DataMonitorPermission.Read;
        _this.bitConditionTypes = _this.bitConditionTypeOptionService.getOptions();
        _this.bitCondition = new BitConditionModel('', '', BitConditonLogic.On, 0, false, 0);
        return _this;
    }
    Object.defineProperty(BitConditionComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentVariableId)) {
                return;
            }
            this._currentVariableId = v;
            if (v && !this.isBitwiseIndex) {
                delete this.bitCondition.dataSourceCode;
                delete this.bitCondition.variableGroupName;
                this.bitCondition.variableName = v.name;
                this.bitCondition.variableVersion = v.variableVersion;
            }
            else {
                delete this.bitCondition.dataSourceCode;
                delete this.bitCondition.variableGroupName;
                this.bitCondition.variableName = '';
                this.bitCondition.variableVersion = undefined;
            }
            this.bitCondition.isBitwiseIndex = false;
            this.bitCondition.bitIndex = 0;
            this.variableNameChangeEvent.emit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitConditionComponent.prototype, "currentBitwiseVariableId", {
        get: function () {
            return this._currentBitwiseVariableId;
        },
        set: function (v) {
            var _this = this;
            if (VariableName.equals(v, this._currentBitwiseVariableId)) {
                return;
            }
            this._currentBitwiseVariableId = v;
            if (v && this.isBitwiseIndex) {
                delete this.bitCondition.dataSourceCode;
                delete this.bitCondition.variableGroupName;
                this.bitCondition.variableName = v.name;
                this.bitCondition.variableVersion = v.variableVersion;
                this.bitCondition.isBitwiseIndex = this.isBitwiseIndex;
                this.bitCondition.bitIndex = this.bitIndex;
                this.variableService.findVariable(v)
                    .subscribe(function (variable) {
                    _this.setMaxBitIndex(variable.dataType);
                });
            }
            else {
                this.bitCondition.isBitwiseIndex = false;
                this.bitCondition.bitIndex = 0;
                this.bitCondition.variableName = '';
                this.bitCondition.variableVersion = null;
                delete this.bitCondition.dataSourceCode;
                delete this.bitCondition.variableGroupName;
            }
            this.variableNameChangeEvent.emit();
        },
        enumerable: true,
        configurable: true
    });
    BitConditionComponent.prototype.changeBitwiseIndex = function () {
        this.isBitwiseIndex = !this.isBitwiseIndex;
    };
    BitConditionComponent.prototype.changeBitIndex = function (ev) {
        this.bitCondition.bitIndex = this.bitIndex;
        this.bitIndexChangeEvent.emit();
    };
    BitConditionComponent.prototype.onChangeBitConditionType = function (value) {
        this.bitCondition.bitConditionLogic = value;
    };
    BitConditionComponent.prototype.isVariableNameEmpty = function () {
        return !this.bitCondition.variableName;
    };
    BitConditionComponent.prototype.getCondition = function () {
        return this.bitCondition;
    };
    BitConditionComponent.prototype.setCondition = function (bitCondition) {
        this.bitCondition = new BitConditionModel(bitCondition.variableName, bitCondition.variableGroupName, bitCondition.bitConditionLogic, bitCondition.dataSourceCode, bitCondition.isBitwiseIndex, bitCondition.bitIndex, bitCondition.dataType);
        this.isBitwiseIndex = bitCondition.isBitwiseIndex ? bitCondition.isBitwiseIndex : false;
        if (this.isBitwiseIndex) {
            this.bitIndex = bitCondition.bitIndex;
            this.setBitwiseVariable(bitCondition);
        }
        else {
            this.setVariable(bitCondition);
        }
    };
    BitConditionComponent.prototype.setBitwiseVariable = function (bitCondition) {
        var _this = this;
        if (bitCondition.variableVersion) {
            this.currentBitwiseVariableId = VariableName.tryParse(bitCondition.variableName, bitCondition.variableVersion);
        }
        else if (!_.isNil(bitCondition.dataSourceCode)) {
            this.variableService.getVariableName(bitCondition.dataSourceCode, bitCondition.variableName, bitCondition.variableGroupName).subscribe(function (value) {
                _this.currentBitwiseVariableId = value;
            });
        }
    };
    BitConditionComponent.prototype.setVariable = function (bitCondition) {
        var _this = this;
        if (bitCondition.variableVersion) {
            this.currentVariableId = VariableName.tryParse(bitCondition.variableName, bitCondition.variableVersion);
        }
        else if (!_.isNil(bitCondition.dataSourceCode)) {
            this.variableService.getVariableName(bitCondition.dataSourceCode, bitCondition.variableName, bitCondition.variableGroupName).subscribe(function (value) {
                _this.currentVariableId = value;
            });
        }
    };
    BitConditionComponent.prototype.setMaxBitIndex = function (dataType) {
        this.maxBitIndex = calcMaxBitIndex(dataType);
        this.bitCondition.dataType = dataType;
    };
    BitConditionComponent.prototype.isBitIndexWithinScope = function () {
        if (!this.bitIndex && this.bitIndex !== 0) {
            return true;
        }
        var canSave = true;
        if (this.bitIndex >= 0 && this.bitIndex <= this.maxBitIndex) {
            canSave = false;
        }
        return canSave;
    };
    __decorate([
        Output()
    ], BitConditionComponent.prototype, "variableNameChangeEvent", void 0);
    __decorate([
        Output()
    ], BitConditionComponent.prototype, "bitIndexChangeEvent", void 0);
    __decorate([
        Input()
    ], BitConditionComponent.prototype, "configureId", void 0);
    BitConditionComponent = __decorate([
        Component({
            selector: 'bit-condition',
            styles: [".modal-content { width: 600px; } .row.no-gutter { margin-left: 5; margin-right: 0; } .row.no-gutter>[class*='col-'] { padding-right: 0; padding-left: 0; } .margin-top-5 { margin-top: 5px; } .condition-input{ padding-left:0px; padding-right:0px; height:30px } .condition-input-value{ flex: 0 0 37%; max-width: 37%; padding-right:0px; } .input-common{ padding:0; height:30px; } .i-required{ margin-right: 5px; color:red; display: inline-block; } .i-required-longer { color:red; position: relative; left: 0px; } .data-source-combo select{ width:100%; } .read-value,.variable-select{ width: 60px; display: inline-block; } .read-value{ width: 80px; float: left; } .sign-select,.variable-select{ margin-left: 10px; float: left; } .sign-select{ width: 100px; } .variable-input{ width: 115px; border: 1px solid #d7dbe5; height: 30px; margin-left: 10px; padding: 0 10px; } .logic-select{ width: 100px; } .logic-select>select{ width: 100px!important; border-color: #d7dbe5; } .variable-selector{ position: relative; left: 80px; width:calc(100% - 85px) ; height: 30px; display: inline-block; } .required-body{ width: 485px; } .label-width-wordOrBitCondition{ width: 80px; height: 30px; } .input-width-wordOrBitCondition{ width: calc(100% - 85px); } .interval{ margin-top: 10px; } .fe-transverse-component{ position: relative; } .variable-input-i{ position: absolute; right: -12px; } .variable-selector-i{ position: absolute; top: 5px; left: -77px; } .condition{ padding-left:10px; box-sizing: border-box;  } .word-condition .fe-transverse-title,.bit-condition .fe-transverse-title{ margin-right: 0; } .word-condition-input{ width: calc(100% - 85px); } .warn-color{ color: red; margin-left: 80px; } .default-input{ height: 30px; border: 1px solid #d7dbe5; } .bitwise-label{ width: 100px; } .bitwise-variable{ width: calc(100% - 205px); } .bitwise-bitIndex{ width: 110px; height: 30px; } .point{ height: 30px; float: left; width: 10px; text-align: center; }"],
            template: "<div class=\"bit-condition\"> <div class=\"fe-option-head\"> <label for=\"isBitwiseIndex\"> <input id=\"isBitwiseIndex\" type=\"checkbox\" [checked]=\"isBitwiseIndex\" (change)=\"changeBitwiseIndex()\" > <span>{{lc('UseWordRegister')}}</span> </label> </div> <div class=\"fe-transverse-label clearfix margin-top-5\"> <div class=\"fe-transverse-title   label-width-wordOrBitCondition\"> <i class=\"i-required-longer\">*</i> {{lc('Variable')}}： </div> <div class=\"fe-transverse-component input-width-wordOrBitCondition\" *ngIf=\"!isBitwiseIndex\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentVariableId\" [dataType]=\"dataType\" [readWriteModel]=\"readModel\"></variable-selector> </div> <div class=\"fe-transverse-component input-width-wordOrBitCondition\" [ngClass]=\"currentBitwiseVariableId ? 'bitwise-variable' : ''\" *ngIf=\"isBitwiseIndex\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentBitwiseVariableId\" [dataType]=\"bitwiseDataType\" [readWriteModel]=\"readModel\"></variable-selector> </div> <div class=\"point\" *ngIf=\"currentBitwiseVariableId && isBitwiseIndex\">.</div> <input type=\"number\" class=\"bitwise-bitIndex\" [(ngModel)]=\"bitIndex\" name=\"bitIndex\" (keyup)=\"changeBitIndex($event)\" (change)=\"changeBitIndex($event)\" *ngIf=\"currentBitwiseVariableId && isBitwiseIndex\" required> </div> <div class=\"fe-transverse-label warn-color\" *ngIf=\"isBitwiseIndex && (bitIndex < 0 || bitIndex > maxBitIndex || (!bitIndex && bitIndex != 0))\"> {{lc(\"PleaseEnterDigits\",maxBitIndex)}} </div> <div class=\"fe-transverse-label interval clearfix\"> <div class=\"fe-transverse-title label-width-wordOrBitCondition condition\"> {{lc('Condition')}} </div> <div class=\"fe-transverse-component fe-radio-select-header\"> <label> <input type=\"radio\" value=\"1\" [checked]=\"bitCondition.bitConditionLogic === 1\" (change)=\"onChangeBitConditionType(1)\" name=\"rdBitConditionType\"> <span>ON</span> </label> <label class=\"margin-left-80\"> <input type=\"radio\" value=\"0\" [checked]=\"bitCondition.bitConditionLogic === 0\" (change)=\"onChangeBitConditionType(0)\" name=\"rdBitConditionType\"> <span>OFF</span> </label> </div> </div> </div> "
        }),
        __param(2, Inject(VARIABLE_SERVICE))
    ], BitConditionComponent);
    return BitConditionComponent;
}(ConfigureComponentBase));
export { BitConditionComponent };
